<template>
  <div>
    <loader v-if="loading" fill-color="black" />
    <div style="position: relative; width: 100%;" v-else>
      <input
        type="text"
        v-model="content"
        :list="`${id}_suggestions`"
        :placeholder="placeholder"
        :class="inputClass"
        ref="datalistInput"
        style="width: 100%; padding-right: 30px; box-sizing: border-box;"
        @focus="fetchSuggestions"
        @input="fetchSuggestions"
      />
      <!-- Dropdown arrow icon -->
      <span
        style="
          position: absolute;
          right: 10px;
          top: 50%;
          transform: translateY(-50%);
          pointer-events: none;
        "
      >▼</span>
    </div>
    <p v-if="fetchError" class="text-red text-sm mt-1">{{ fetchError }}</p>
    <datalist :id="`${id}_suggestions`">
      <option v-for="(option, index) in suggestions" :key="index" :value="option.name" />
    </datalist>
  </div>
</template>

<script>
import { v2Api } from '@/http'
import randomstring from 'randomstring'
import { mapState } from 'vuex'

export default {
  props: {
    value: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: ''
    },
    inputClass: {
      type: String,
      default: 'w-full bg-white rounded h-10 py-0 px-2 shadow text-sm border text-grey-darkest'
    },
    typeId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      id: randomstring.generate(),
      suggestions: [],
      content: this.value,
      loading: false,
      fetchError: ''
    }
  },
  computed: {
    ...mapState(['selectedOffice'])
  },
  mounted () {
    this.loading = true
    this.fetchSuggestions().finally(() => {
      this.loading = false
    })
  },

  methods: {
    fetchSuggestions () {
      // Don't refetch if already loaded
      if (this.suggestions.length) return Promise.resolve()

      let type = 'PropertySchemaApplicantSellingPosition'
      if (this.typeId === 2) {
        type = 'PropertySchemaApplicantBuyingPosition'
      } else if (this.typeId === 3) {
        type = 'PropertySchemaApplicantBuyingReason'
      }

      return v2Api.get('crm/status/suggest', {
        params: {
          crm_instance_id: this.selectedOffice.crm_instance_id,
          type
        }
      }).then((response) => {
        this.suggestions = response.data || []
        this.fetchError = ''
      }).catch(() => {
        this.fetchError = 'Failed to load CRM data. You can type it manually instead.'
      })
    },
    handleDropdownClick () {
      const input = this.$refs.datalistInput
      if (!input) return
      const original = this.content
      this.content = '__temp__'
      input.focus()
      this.$nextTick(() => {
        this.content = original
      })
    }
  },

  watch: {
    content (val) {
      this.$emit('input', val)
    }
  }
}
</script>
